import React from 'react';
import styles from '../styles/StreakReminderModal.module.css';

interface StreakReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPlayNow?: () => void;
  currentStreak: number;
}

export const StreakReminderModal: React.FC<StreakReminderModalProps> = ({
  isOpen,
  onClose,
  onPlayNow,
  currentStreak,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.reminderOverlay} onClick={onClose}>
      <div className={styles.reminderModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.reminderHeader}>
          <h2 className={styles.reminderTitle}>⚡ Streak Reminder</h2>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>
        
        <div className={styles.reminderContent}>
          <p className={styles.streakMessage}>
            Your streak for weekly leaderboard is <strong>{currentStreak}/30</strong>, remember to play the game today to maintain and build up your streak.
          </p>
          
          <p className={styles.warningMessage}>
            Otherwise it will be reset to 0 tomorrow.
          </p>
        </div>

        <div className={styles.reminderActions}>
          <button className={styles.playNowButton} onClick={onPlayNow || onClose}>
            Play Now!
          </button>
        </div>
      </div>
    </div>
  );
};